//Reset data
export const RESET = "POINT_FOCAUX_LIST_RESET"

//Loading
export const SET_TOGGLE_LOADING = "POINT_FOCAUX_LIST_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "POINT_FOCAUX_LIST_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "POINT_FOCAUX_LIST_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "POINT_FOCAUX_LIST_SET_MESSAGE"
export const SET_IS_SUCCESS = "POINT_FOCAUX_LIST_SET_IS_SUCCESS"
export const SET_IS_ERROR = "POINT_FOCAUX_LIST_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "POINT_FOCAUX_LIST_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "POINT_FOCAUX_LIST_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "POINT_FOCAUX_LIST_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "POINT_FOCAUX_LIST_SET_ITEMS"
export const SET_CURRENT_ITEM = "POINT_FOCAUX_LIST_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "POINT_FOCAUX_LIST_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "POINT_FOCAUX_LIST_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "POINT_FOCAUX_LIST_SET_HIDE_MODAL"


export const SET_MODAL = "POINT_FOCAUX_LIST_SET_MODAL"
export const SET_MODAL_CONTENT = "POINT_FOCAUX_LIST_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "POINT_FOCAUX_LIST_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "POINT_FOCAUX_LIST_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "POINT_FOCAUX_LIST_SET_MODAL_TYPE"